import React from 'react'

/**
 * Iterate over player stats and markup one span for each stat. Wrap it in li.
 *
 * @param {Array} stats         players stats
 * @param {Array} excludeStats  list of stats that need not be shown
 *                              e.g. ['R', 'B']
 * @return {React.Element} list of stats
 */
export const PlayerStats = ({
  stats = [],
  excludeStats = []
}) => {
  // init stats string
  let allStats = ''
  stats.map(function (stat = {}) {
    // Display stat only if it is not found in excludeStats array
    if (excludeStats.indexOf(stat.text) == -1 && stat.value !== '-') {
      allStats += `<span class="cricinfo__table__list__item__label">${stat.text}: </span>${stat.value}`
    }
  })

  let allStatsMarkup = { __html : allStats }

  return (
    <li className="cricinfo__table__list__item" dangerouslySetInnerHTML={allStatsMarkup}></li>
  )
}

export default PlayerStats



// WEBPACK FOOTER //
// ../app/components/common/PlayerStats.jsx